<div id="ewsSync" fxLayout="column" fxLayoutGap="16px" *ngIf="syncMember">
  <mat-checkbox [ngModel]="syncActive"
                (ngModelChange)="setSyncActive($event)"
                [disabled]="!canEdit">
    {{ 'ews_sync.switch_label' | translate}}
  </mat-checkbox>
  <p>
    {{ 'ews_sync.description' | translate}}
  </p>
  <p>
    {{ 'ews_sync.description2' | translate}}
  </p>
</div>
